import './gmap.css';

import MapModel from './gmapModel';
import { MapView } from './gmapView';

export const MapController = Backbone.View.extend({
  initialize: function(searchModel = false) {
    this.domainListJsonUrl = GMAP_SCRIPTS.URL_MAP_PARTIAL;
    this.searchModel = searchModel;

    this.listenTo(dispatcher, 'gmap:initGmap', this.initGmap);
    this.listenTo(dispatcher, 'gmap:initGmapScrollbar', this.initGmapScrollbar);
  },

  initGmap: function (data = {}) {
    const oData = (typeof data === 'string') ? JSON.parse(JSON.stringify(data)) : data;
    const housingMatch = oData.match(/'housing_code:(\d+)'/);

    let housingCode = housingMatch ? housingMatch[1] : null;

    this.model = new MapModel();
    this.model.set('device', DEVICE, {'silent': true});
    this.mapView = new MapView({
      element: '.js-gmaps',
      mapSelectorId: 'js-gmaps-map',
      zoom: '',
      displayByDefault: false,
      domainListJsonUrl: this.domainListJsonUrl,
      model: this.model,
      selectedProductCode: typeof oData.selectedProduct !== typeof undefined ? oData.selectedProduct : null,
      ajaxParams: typeof oData.ajaxParams !== typeof undefined ? oData.ajaxParams : null,
      searchModel: this.searchModel,
      housingParam: housingCode
    });
  }
});